const mediaQuery = {
  xsmall: '@media screen and (max-width: 599px)',
  small: '@media screen and (max-width: 1023px)',

  aboveXsmall: '@media screen and (min-width: 600px)',
  aboveSmall: '@media screen and (min-width: 1024px)',

  medium: '@media screen and (min-width: 1024px) and (max-width: 1440px)',
  large: '@media screen and (min-width: 1441px)',
};

export default mediaQuery;
